import React from 'react';
import Crossword from '../games/Crossword/Crossword';
import AdPlaceholder from '../components/AdPlaceholder';
import SeoHead from '../components/SeoHead';
import './GamePage.css';

export default function CrosswordPage() {
  return (
    <main className="game-page">
      <SeoHead
        title="Hidden Words"
        description="Daily 8×8 word search — same puzzle as the app for everyone (local calendar day). Tap letters in a straight line, then Submit word to match hidden words (4–8 letters). Calm puzzles, no time limit."
        path="/crossword"
      />
      <div className="game-page-ad">
        <AdPlaceholder variant="game-top" />
      </div>
      <Crossword />
    </main>
  );
}
